module.exports = __webpack_public_path__ + "assets/img/page-title-e6162bc3.png";